import { render, staticRenderFns } from "./yes_no.vue?vue&type=template&id=649257de&scoped=true&"
import script from "./yes_no.vue?vue&type=script&lang=js&"
export * from "./yes_no.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649257de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649257de')) {
      api.createRecord('649257de', component.options)
    } else {
      api.reload('649257de', component.options)
    }
    module.hot.accept("./yes_no.vue?vue&type=template&id=649257de&scoped=true&", function () {
      api.rerender('649257de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/yes_no.vue"
export default component.exports